import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Stick from '../../../es';
import Regression from './Regression';
function StickOnHover() {
    return (_jsx(Regression, { allBrowsers: true, fixed: true, version: "3.0.3", title: "Node does not unmount on mouse leave", description: "Move your mouse over the squares. When you're hovering one another node should be shown. However, there should always only be one node at the same time.", children: _jsx("div", { style: { display: 'flex', flexWrap: 'wrap' }, children: Array(100)
                .fill(null)
                .map((_, i) => (_jsx("div", { style: { marginLeft: 20, marginBottom: 20 }, children: _jsx(Popover, {}) }, i))) }) }));
}
function Popover() {
    const [hover, setHover] = useState(false);
    return (_jsx(Stick, { position: "top center", node: hover && _jsx(Node, {}), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), children: _jsx(Anchor, {}) }));
}
const Anchor = () => (_jsx("div", { style: {
        height: 30,
        width: 30,
        backgroundColor: 'rgb(24, 170, 177)',
    } }));
const Node = ({ children }) => (_jsx("div", { style: {
        backgroundColor: '#ae0d5c',
        width: 10,
        height: 10,
    }, children: children }));
export default StickOnHover;
